import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ShareModal.module.css";


export default function ShareModal({ isOpen, onClose }) {
    const [shareUrl, setShareUrl] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    const [error, setError] = useState('');
    
    // Get Redux state
    const visualizerState = useSelector(state => state.visualizer);
    const floorplanState = useSelector(state => state.floorplan);

    // Generate share URL using URL shortener
    useEffect(() => {
        if (isOpen) {
            generateShareUrl();
        }
    }, [isOpen]);

    const generateShareUrl = async () => {
        setIsGenerating(true);
        setError('');
        
        try {
            // Check if IMWC is available
            if (!window.IMWC || !window.IMWC.lizard || !window.IMWC.lizard.getShortener) {
                throw new Error('URL shortener not available. Please ensure Chameleon components are loaded.');
            }

            // Get session storage data
            const visualizerData = localStorage.getItem('persist:visualizer');
            const floorplanData = localStorage.getItem('persist:floorplan');
            
            if (!visualizerData) {
                throw new Error('No visualizer data found.');
            }
            
            if (!floorplanData) {
                throw new Error('No floorplan data found.');
            }
            
            // Prepare data to save
            const shareData = {
                visualizer: visualizerData,
                floorplan: floorplanData,
                timestamp: new Date().toISOString()
            };

            // Create base URL with #code# placeholder
            const baseUrl = `${window.location.origin}/shared/#code#`;
            
            // Call URL shortener
            const response = await window.IMWC.lizard.getShortener(
                baseUrl,
                'BuffingtonHomes',
                JSON.stringify(shareData),
                null
            );

            console.log('Shortener response:', response);

            if (response.success && response.data && response.data.shortUrl) {
                setShareUrl(response.data.shortUrl);
            } else {
                throw new Error('Failed to generate share URL');
            }

        } catch (err) {
            console.error('Error generating share URL:', err);
            setError(err.message || 'Failed to generate share URL');
            // Fallback to current URL
            setShareUrl(window.location.href);
        } finally {
            setIsGenerating(false);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            alert('Link copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy: ', err);
            alert('Failed to copy link');
        }
    };

    if (!isOpen) return null;

    return (
        <PopUpModal 
            handleClose={onClose}
            size="medium"
            title="Share Your Project"
            ariaLabelledBy="share-modal-title"
        >
            <div className={styles.contentMain}>
                <h2 id="share-modal-title">Share Your Project</h2>
                
                {error && (
                    <div className={styles.errorMessage}>
                        {error}
                    </div>
                )}
                
                <div className={styles.flexRow}>
                    <div className={styles.shareUrlContainer}>
                        <div className={styles.inputWrapper}>
                            <label htmlFor="shareUrl">Share URL</label>
                            <input 
                                id="shareUrl"
                                type="text"
                                value={isGenerating ? 'Generating share link...' : shareUrl}
                                readOnly
                                className={styles.shareUrlInput}
                                disabled={isGenerating}
                            />
                        </div>
                        <button 
                            className={styles.copyButton}
                            onClick={handleCopy}
                            disabled={isGenerating || !shareUrl}
                        >
                            {isGenerating ? 'GENERATING...' : 'COPY'}
                        </button>
                    </div>
                </div>
                
                {!isGenerating && shareUrl && (
                    <div className={styles.shareInfo}>
                        <p>Share this link to let others view your design selections.</p>
                    </div>
                )}
            </div>
        </PopUpModal>
    );
}
